/*

GOD IS A DJ!
         ,   ,
        /////|
       ///// |
      /////  |
     |~~~| | |
     |===| |/|
     | B |/| |
     | I | | |
     | B | | |
     | L |  /
     | E | /
     |===|/
     '---'
*/

class ProductEngraving extends HTMLElement {
  constructor() {
    super();

    this.illegalCharsRegex =
      /[^a-zA-Z0-9 \'\-_.,;:?!*/€£$µ%&+=°~′\`^¨ˇ«»()[\]{}#@]/g;

    this.profanitySet = new Set([
      "abbo",
      "abo",
      "abortion",
      "abuse",
      "addict",
      "addicts",
      "adult",
      "africa",
      "african",
      "alla",
      "allah",
      "alligatorbait",
      "amateur",
      "american",
      "anal",
      "analannie",
      "analsex",
      "angie",
      "angry",
      "anus",
      "arab",
      "arabs",
      "areola",
      "argie",
      "aroused",
      "arse",
      "arsehole",
      "asian",
      "ass",
      "assassin",
      "assassinate",
      "assassination",
      "assault",
      "assbagger",
      "assblaster",
      "assclown",
      "asscowboy",
      "asses",
      "assfuck",
      "assfucker",
      "asshat",
      "asshole",
      "assholes",
      "asshore",
      "assjockey",
      "asskiss",
      "asskisser",
      "assklown",
      "asslick",
      "asslicker",
      "asslover",
      "assman",
      "assmonkey",
      "assmunch",
      "assmuncher",
      "asspacker",
      "asspirate",
      "asspuppies",
      "assranger",
      "asswhore",
      "asswipe",
      "athletesfoot",
      "attack",
      "australian",
      "babe",
      "babies",
      "backdoor",
      "backdoorman",
      "backseat",
      "badfuck",
      "balllicker",
      "balls",
      "ballsack",
      "banging",
      "baptist",
      "barelylegal",
      "barf",
      "barface",
      "barfface",
      "bast",
      "bastard",
      "bazongas",
      "bazooms",
      "beaner",
      "beast",
      "beastality",
      "beastial",
      "beastiality",
      "beatoff",
      "beat-off",
      "beatyourmeat",
      "beaver",
      "bestial",
      "bestiality",
      "bi",
      "biatch",
      "bible",
      "bicurious",
      "bigass",
      "bigbastard",
      "bigbutt",
      "bigger",
      "bisexual",
      "bi-sexual",
      "bitch",
      "bitcher",
      "bitches",
      "bitchez",
      "bitchin",
      "bitching",
      "bitchslap",
      "bitchy",
      "biteme",
      "black",
      "blackman",
      "blackout",
      "blacks",
      "blind",
      "blow",
      "blowjob",
      "boang",
      "bogan",
      "bohunk",
      "bollick",
      "bollock",
      "bomb",
      "bombers",
      "bombing",
      "bombs",
      "bomd",
      "bondage",
      "boner",
      "bong",
      "boob",
      "boobies",
      "boobs",
      "booby",
      "boody",
      "boom",
      "boong",
      "boonga",
      "boonie",
      "booty",
      "bootycall",
      "bountybar",
      "bra",
      "brea5t",
      "breast",
      "breastjob",
      "breastlover",
      "breastman",
      "brothel",
      "bugger",
      "buggered",
      "buggery",
      "bullcrap",
      "bulldike",
      "bulldyke",
      "bullshit",
      "bumblefuck",
      "bumfuck",
      "bunga",
      "bunghole",
      "buried",
      "burn",
      "butchbabes",
      "butchdike",
      "butchdyke",
      "butt",
      "buttbang",
      "butt-bang",
      "buttface",
      "buttfuck",
      "butt-fuck",
      "buttfucker",
      "butt-fucker",
      "buttfuckers",
      "butt-fuckers",
      "butthead",
      "buttman",
      "buttmunch",
      "buttmuncher",
      "buttpirate",
      "buttplug",
      "buttstain",
      "byatch",
      "cacker",
      "cameljockey",
      "cameltoe",
      "canadian",
      "cancer",
      "carpetmuncher",
      "carruth",
      "catholic",
      "catholics",
      "cemetery",
      "chav",
      "cherrypopper",
      "chickslick",
      "children's",
      "chin",
      "chinaman",
      "chinamen",
      "chinese",
      "chink",
      "chinky",
      "choad",
      "chode",
      "christ",
      "christian",
      "church",
      "cigarette",
      "cigs",
      "clamdigger",
      "clamdiver",
      "clit",
      "clitoris",
      "clogwog",
      "cocaine",
      "cock",
      "cockblock",
      "cockblocker",
      "cockcowboy",
      "cockfight",
      "cockhead",
      "cockknob",
      "cocklicker",
      "cocklover",
      "cocknob",
      "cockqueen",
      "cockrider",
      "cocksman",
      "cocksmith",
      "cocksmoker",
      "cocksucer",
      "cocksuck",
      "cocksucked",
      "cocksucker",
      "cocksucking",
      "cocktail",
      "cocktease",
      "cocky",
      "cohee",
      "coitus",
      "color",
      "colored",
      "coloured",
      "commie",
      "communist",
      "condom",
      "conservative",
      "conspiracy",
      "coolie",
      "cooly",
      "coon",
      "coondog",
      "copulate",
      "cornhole",
      "corruption",
      "cra5h",
      "crabs",
      "crack",
      "crackpipe",
      "crackwhore",
      "crack-whore",
      "crap",
      "crapola",
      "crapper",
      "crappy",
      "crash",
      "creamy",
      "crime",
      "crimes",
      "criminal",
      "criminals",
      "crotch",
      "crotchjockey",
      "crotchmonkey",
      "crotchrot",
      "cum",
      "cumbubble",
      "cumfest",
      "cumjockey",
      "cumm",
      "cummer",
      "cumming",
      "cumquat",
      "cumqueen",
      "cumshot",
      "cunilingus",
      "cunillingus",
      "cunn",
      "cunnilingus",
      "cunntt",
      "cunt",
      "cunteyed",
      "cuntfuck",
      "cuntfucker",
      "cuntlick",
      "cuntlicker",
      "cuntlicking",
      "cuntsucker",
      "cybersex",
      "cyberslimer",
      "dago",
      "dahmer",
      "dammit",
      "damn",
      "damnation",
      "damnit",
      "darkie",
      "darky",
      "datnigga",
      "dead",
      "deapthroat",
      "death",
      "deepthroat",
      "defecate",
      "dego",
      "demon",
      "deposit",
      "desire",
      "destroy",
      "deth",
      "devil",
      "devilworshipper",
      "dick",
      "dickbrain",
      "dickforbrains",
      "dickhead",
      "dickless",
      "dicklick",
      "dicklicker",
      "dickman",
      "dickwad",
      "dickweed",
      "diddle",
      "die",
      "died",
      "dies",
      "dike",
      "dildo",
      "dingleberry",
      "dink",
      "dipshit",
      "dipstick",
      "dirty",
      "disease",
      "diseases",
      "disturbed",
      "dive",
      "dix",
      "dixiedike",
      "dixiedyke",
      "doggiestyle",
      "doggystyle",
      "dong",
      "doodoo",
      "doo-doo",
      "doom",
      "dope",
      "dragqueen",
      "dragqween",
      "dripdick",
      "drug",
      "drunk",
      "drunken",
      "dumb",
      "dumbass",
      "dumbbitch",
      "dumbfuck",
      "dyefly",
      "dyke",
      "easyslut",
      "eatballs",
      "eatme",
      "eatpussy",
      "ecstacy",
      "ejaculate",
      "ejaculated",
      "ejaculating",
      "ejaculation",
      "enema",
      "enemy",
      "erect",
      "erection",
      "ero",
      "escort",
      "ethiopian",
      "ethnic",
      "european",
      "evl",
      "excrement",
      "execute",
      "executed",
      "execution",
      "executioner",
      "explosion",
      "facefucker",
      "faeces",
      "fag",
      "fagging",
      "faggot",
      "fagot",
      "failed",
      "failure",
      "fairies",
      "fairy",
      "faith",
      "fannyfucker",
      "fart",
      "farted",
      "farting",
      "farty",
      "fastfuck",
      "fat",
      "fatah",
      "fatass",
      "fatfuck",
      "fatfucker",
      "fatso",
      "fckcum",
      "fear",
      "feces",
      "felatio",
      "felch",
      "felcher",
      "felching",
      "fellatio",
      "feltch",
      "feltcher",
      "feltching",
      "fetish",
      "fight",
      "filipina",
      "filipino",
      "fingerfood",
      "fingerfuck",
      "fingerfucked",
      "fingerfucker",
      "fingerfuckers",
      "fingerfucking",
      "fire",
      "firing",
      "fister",
      "fistfuck",
      "fistfucked",
      "fistfucker",
      "fistfucking",
      "fisting",
      "flange",
      "flasher",
      "flatulence",
      "floo",
      "flydie",
      "flydye",
      "fok",
      "fondle",
      "footaction",
      "footfuck",
      "footfucker",
      "footlicker",
      "footstar",
      "fore",
      "foreskin",
      "forni",
      "fornicate",
      "foursome",
      "fourtwenty",
      "fraud",
      "freakfuck",
      "freakyfucker",
      "freefuck",
      "fu",
      "fubar",
      "fuc",
      "fucck",
      "fuck",
      "fucka",
      "fuckable",
      "fuckbag",
      "fuckbuddy",
      "fucked",
      "fuckedup",
      "fucker",
      "fuckers",
      "fuckface",
      "fuckfest",
      "fuckfreak",
      "fuckfriend",
      "fuckhead",
      "fuckher",
      "fuckin",
      "fuckina",
      "fucking",
      "fuckingbitch",
      "fuckinnuts",
      "fuckinright",
      "fuckit",
      "fuckknob",
      "fuckme",
      "fuckmehard",
      "fuckmonkey",
      "fuckoff",
      "fuckpig",
      "fucks",
      "fucktard",
      "fuckwhore",
      "fuckyou",
      "fudgepacker",
      "fugly",
      "fuk",
      "fuks",
      "funeral",
      "funfuck",
      "fungus",
      "fuuck",
      "gangbang",
      "gangbanged",
      "gangbanger",
      "gangsta",
      "gatorbait",
      "gay",
      "gaymuthafuckinwhore",
      "gaysex",
      "geez",
      "geezer",
      "geni",
      "genital",
      "german",
      "getiton",
      "gin",
      "ginzo",
      "gipp",
      "girls",
      "givehead",
      "glazeddonut",
      "gob",
      "god",
      "godammit",
      "goddamit",
      "goddammit",
      "goddamn",
      "goddamned",
      "goddamnes",
      "goddamnit",
      "goddamnmuthafucker",
      "goldenshower",
      "gonorrehea",
      "gonzagas",
      "gook",
      "gotohell",
      "goy",
      "goyim",
      "greaseball",
      "gringo",
      "groe",
      "gross",
      "grostulation",
      "gubba",
      "gummer",
      "gun",
      "gyp",
      "gypo",
      "gypp",
      "gyppie",
      "gyppo",
      "gyppy",
      "hamas",
      "handjob",
      "hapa",
      "harder",
      "hardon",
      "harem",
      "headfuck",
      "headlights",
      "hebe",
      "heeb",
      "hell",
      "henhouse",
      "heroin",
      "herpes",
      "heterosexual",
      "hijack",
      "hijacker",
      "hijacking",
      "hillbillies",
      "hindoo",
      "hiscock",
      "hitler",
      "hitlerism",
      "hitlerist",
      "hiv",
      "hobo",
      "hodgie",
      "hoes",
      "hole",
      "holestuffer",
      "homicide",
      "homo",
      "homobangers",
      "homosexual",
      "honger",
      "honk",
      "honkers",
      "honkey",
      "honky",
      "hook",
      "hooker",
      "hookers",
      "hooters",
      "hore",
      "hork",
      "horn",
      "horney",
      "horniest",
      "horny",
      "horseshit",
      "hosejob",
      "hoser",
      "hostage",
      "hotdamn",
      "hotpussy",
      "hottotrot",
      "hummer",
      "husky",
      "hussy",
      "hustler",
      "hymen",
      "hymie",
      "iblowu",
      "idiot",
      "ikey",
      "illegal",
      "incest",
      "insest",
      "intercourse",
      "interracial",
      "intheass",
      "inthebuff",
      "israel",
      "israeli",
      "israel's",
      "italiano",
      "itch",
      "jackass",
      "jackoff",
      "jackshit",
      "jacktheripper",
      "jade",
      "jap",
      "japanese",
      "japcrap",
      "jebus",
      "jeez",
      "jerkoff",
      "jesus",
      "jesuschrist",
      "jew",
      "jewish",
      "jiga",
      "jigaboo",
      "jigg",
      "jigga",
      "jiggabo",
      "jigger",
      "jiggy",
      "jihad",
      "jijjiboo",
      "jimfish",
      "jism",
      "jiz",
      "jizim",
      "jizjuice",
      "jizm",
      "jizz",
      "jizzim",
      "jizzum",
      "joint",
      "juggalo",
      "jugs",
      "junglebunny",
      "kaffer",
      "kaffir",
      "kaffre",
      "kafir",
      "kanake",
      "kid",
      "kigger",
      "kike",
      "kill",
      "killed",
      "killer",
      "killing",
      "kills",
      "kink",
      "kinky",
      "kissass",
      "kkk",
      "knife",
      "knockers",
      "kock",
      "kondum",
      "koon",
      "kotex",
      "krap",
      "krappy",
      "kraut",
      "kum",
      "kumbubble",
      "kumbullbe",
      "kummer",
      "kumming",
      "kumquat",
      "kums",
      "kunilingus",
      "kunnilingus",
      "kunt",
      "ky",
      "kyke",
      "lactate",
      "laid",
      "lapdance",
      "latin",
      "lesbain",
      "lesbayn",
      "lesbian",
      "lesbin",
      "lesbo",
      "lez",
      "lezbe",
      "lezbefriends",
      "lezbo",
      "lezz",
      "lezzo",
      "liberal",
      "libido",
      "licker",
      "lickme",
      "lies",
      "limey",
      "limpdick",
      "limy",
      "lingerie",
      "liquor",
      "livesex",
      "loadedgun",
      "lolita",
      "looser",
      "loser",
      "lotion",
      "lovebone",
      "lovegoo",
      "lovegun",
      "lovejuice",
      "lovemuscle",
      "lovepistol",
      "loverocket",
      "lowlife",
      "lsd",
      "lubejob",
      "lucifer",
      "luckycammeltoe",
      "lugan",
      "lynch",
      "macaca",
      "mad",
      "mafia",
      "magicwand",
      "mams",
      "manhater",
      "manpaste",
      "marijuana",
      "mastabate",
      "mastabater",
      "masterbate",
      "masterblaster",
      "mastrabator",
      "masturbate",
      "masturbating",
      "mattressprincess",
      "meatbeatter",
      "meatrack",
      "meth",
      "mexican",
      "mgger",
      "mggor",
      "mickeyfinn",
      "mideast",
      "milf",
      "minority",
      "mockey",
      "mockie",
      "mocky",
      "mofo",
      "moky",
      "moles",
      "molest",
      "molestation",
      "molester",
      "molestor",
      "moneyshot",
      "mooncricket",
      "mormon",
      "moron",
      "moslem",
      "mosshead",
      "mothafuck",
      "mothafucka",
      "mothafuckaz",
      "mothafucked",
      "mothafucker",
      "mothafuckin",
      "mothafucking",
      "mothafuckings",
      "motherfuck",
      "motherfucked",
      "motherfucker",
      "motherfuckin",
      "motherfucking",
      "motherfuckings",
      "motherlovebone",
      "muff",
      "muffdive",
      "muffdiver",
      "muffindiver",
      "mufflikcer",
      "mulatto",
      "muncher",
      "munt",
      "murder",
      "murderer",
      "muslim",
      "naked",
      "narcotic",
      "nasty",
      "nastybitch",
      "nastyho",
      "nastyslut",
      "nastywhore",
      "nazi",
      "necro",
      "negro",
      "negroes",
      "negroid",
      "negro's",
      "nig",
      "niger",
      "nigerian",
      "nigerians",
      "nigg",
      "nigga",
      "niggah",
      "niggaracci",
      "niggard",
      "niggarded",
      "niggarding",
      "niggardliness",
      "niggardliness's",
      "niggardly",
      "niggards",
      "niggard's",
      "niggaz",
      "nigger",
      "niggerhead",
      "niggerhole",
      "niggers",
      "nigger's",
      "niggle",
      "niggled",
      "niggles",
      "niggling",
      "nigglings",
      "niggor",
      "niggur",
      "niglet",
      "nignog",
      "nigr",
      "nigra",
      "nigre",
      "nip",
      "nipple",
      "nipplering",
      "nittit",
      "nlgger",
      "nlggor",
      "nofuckingway",
      "nook",
      "nookey",
      "nookie",
      "noonan",
      "nooner",
      "nude",
      "nudger",
      "nuke",
      "nutfucker",
      "nymph",
      "ontherag",
      "oral",
      "orga",
      "orgasim",
      "orgasm",
      "orgies",
      "orgy",
      "osama",
      "paki",
      "palesimian",
      "palestinian",
      "pansies",
      "pansy",
      "panti",
      "panties",
      "payo",
      "pearlnecklace",
      "peck",
      "pecker",
      "peckerwood",
      "pee",
      "peehole",
      "pee-pee",
      "peepshow",
      "peepshpw",
      "pendy",
      "penetration",
      "peni5",
      "penile",
      "penis",
      "penises",
      "penthouse",
      "period",
      "perv",
      "phonesex",
      "phuk",
      "phuked",
      "phuking",
      "phukked",
      "phukking",
      "phungky",
      "phuq",
      "pi55",
      "picaninny",
      "piccaninny",
      "pickaninny",
      "piker",
      "pikey",
      "piky",
      "pimp",
      "pimped",
      "pimper",
      "pimpjuic",
      "pimpjuice",
      "pimpsimp",
      "pindick",
      "piss",
      "pissed",
      "pisser",
      "pisses",
      "pisshead",
      "pissin",
      "pissing",
      "pissoff",
      "pistol",
      "pixie",
      "pixy",
      "playboy",
      "playgirl",
      "pocha",
      "pocho",
      "pocketpool",
      "pohm",
      "polack",
      "pom",
      "pommie",
      "pommy",
      "poo",
      "poon",
      "poontang",
      "poop",
      "pooper",
      "pooperscooper",
      "pooping",
      "poorwhitetrash",
      "popimp",
      "porchmonkey",
      "porn",
      "pornflick",
      "pornking",
      "porno",
      "pornography",
      "pornprincess",
      "pot",
      "poverty",
      "premature",
      "pric",
      "prick",
      "prickhead",
      "primetime",
      "propaganda",
      "pros",
      "prostitute",
      "protestant",
      "pu55i",
      "pu55y",
      "pube",
      "pubic",
      "pubiclice",
      "pud",
      "pudboy",
      "pudd",
      "puddboy",
      "puke",
      "puntang",
      "purinapricness",
      "puss",
      "pussie",
      "pussies",
      "pussy",
      "pussycat",
      "pussyeater",
      "pussyfucker",
      "pussylicker",
      "pussylips",
      "pussylover",
      "pussypounder",
      "pusy",
      "quashie",
      "queef",
      "queer",
      "quickie",
      "quim",
      "ra8s",
      "rabbi",
      "racial",
      "racist",
      "radical",
      "radicals",
      "raghead",
      "randy",
      "rape",
      "raped",
      "raper",
      "rapist",
      "rearend",
      "rearentry",
      "rectum",
      "redlight",
      "redneck",
      "reefer",
      "reestie",
      "refugee",
      "reject",
      "remains",
      "rentafuck",
      "republican",
      "rere",
      "retard",
      "retarded",
      "ribbed",
      "rigger",
      "rimjob",
      "rimming",
      "roach",
      "robber",
      "roundeye",
      "rump",
      "russki",
      "russkie",
      "sadis",
      "sadom",
      "samckdaddy",
      "sandm",
      "sandnigger",
      "satan",
      "scag",
      "scallywag",
      "scat",
      "schlong",
      "screw",
      "screwyou",
      "scrotum",
      "scum",
      "semen",
      "seppo",
      "servant",
      "sex",
      "sexed",
      "sexfarm",
      "sexhound",
      "sexhouse",
      "sexing",
      "sexkitten",
      "sexpot",
      "sexslave",
      "sextogo",
      "sextoy",
      "sextoys",
      "sexual",
      "sexually",
      "sexwhore",
      "sexy",
      "sexymoma",
      "sexy-slim",
      "shag",
      "shaggin",
      "shagging",
      "shat",
      "shav",
      "shawtypimp",
      "sheeney",
      "shhit",
      "shinola",
      "shit",
      "shitcan",
      "shitdick",
      "shite",
      "shiteater",
      "shited",
      "shitface",
      "shitfaced",
      "shitfit",
      "shitforbrains",
      "shitfuck",
      "shitfucker",
      "shitfull",
      "shithapens",
      "shithappens",
      "shithead",
      "shithouse",
      "shiting",
      "shitlist",
      "shitola",
      "shitoutofluck",
      "shits",
      "shitstain",
      "shitted",
      "shitter",
      "shitting",
      "shitty",
      "shoot",
      "shooting",
      "shortfuck",
      "showtime",
      "sick",
      "sissy",
      "sixsixsix",
      "sixtynine",
      "sixtyniner",
      "skank",
      "skankbitch",
      "skankfuck",
      "skankwhore",
      "skanky",
      "skankybitch",
      "skankywhore",
      "skinflute",
      "skum",
      "skumbag",
      "slant",
      "slanteye",
      "slapper",
      "slaughter",
      "slav",
      "slave",
      "slavedriver",
      "sleezebag",
      "sleezeball",
      "slideitin",
      "slime",
      "slimeball",
      "slimebucket",
      "slopehead",
      "slopey",
      "slopy",
      "slut",
      "sluts",
      "slutt",
      "slutting",
      "slutty",
      "slutwear",
      "slutwhore",
      "smack",
      "smackthemonkey",
      "smut",
      "snatch",
      "snatchpatch",
      "snigger",
      "sniggered",
      "sniggering",
      "sniggers",
      "snigger's",
      "sniper",
      "snot",
      "snowback",
      "snownigger",
      "sob",
      "sodom",
      "sodomise",
      "sodomite",
      "sodomize",
      "sodomy",
      "sonofabitch",
      "sonofbitch",
      "sooty",
      "sos",
      "soviet",
      "spaghettibender",
      "spaghettinigger",
      "spank",
      "spankthemonkey",
      "sperm",
      "spermacide",
      "spermbag",
      "spermhearder",
      "spermherder",
      "spic",
      "spick",
      "spig",
      "spigotty",
      "spik",
      "spit",
      "spitter",
      "splittail",
      "spooge",
      "spreadeagle",
      "spunk",
      "spunky",
      "squaw",
      "stagg",
      "stiffy",
      "strapon",
      "stringer",
      "stripclub",
      "stroke",
      "stroking",
      "stupid",
      "stupidfuck",
      "stupidfucker",
      "suck",
      "suckdick",
      "sucker",
      "suckme",
      "suckmyass",
      "suckmydick",
      "suckmytit",
      "suckoff",
      "suicide",
      "swallow",
      "swallower",
      "swalow",
      "swastika",
      "sweetness",
      "syphilis",
      "taboo",
      "taff",
      "tampon",
      "tang",
      "tantra",
      "tarbaby",
      "tard",
      "teat",
      "terror",
      "terrorist",
      "teste",
      "testicle",
      "testicles",
      "thicklips",
      "thirdeye",
      "thirdleg",
      "threesome",
      "threeway",
      "timbernigger",
      "tinkle",
      "tit",
      "titbitnipply",
      "titfuck",
      "titfucker",
      "titfuckin",
      "titjob",
      "titlicker",
      "titlover",
      "tits",
      "tittie",
      "titties",
      "titty",
      "tnt",
      "toilet",
      "tongethruster",
      "tongue",
      "tonguethrust",
      "tonguetramp",
      "tortur",
      "torture",
      "tosser",
      "towelhead",
      "trailertrash",
      "tramp",
      "trannie",
      "tranny",
      "transexual",
      "transsexual",
      "transvestite",
      "triplex",
      "trisexual",
      "trojan",
      "trots",
      "tuckahoe",
      "tunneloflove",
      "turd",
      "turnon",
      "twat",
      "twink",
      "twinkie",
      "twobitwhore",
      "uck",
      "uk",
      "unfuckable",
      "upskirt",
      "uptheass",
      "upthebutt",
      "urinary",
      "urinate",
      "urine",
      "usama",
      "uterus",
      "vagina",
      "vaginal",
      "vatican",
      "vibr",
      "vibrater",
      "vibrator",
      "vietcong",
      "violence",
      "virgin",
      "virginbreaker",
      "vomit",
      "vulva",
      "wab",
      "wank",
      "wanker",
      "wanking",
      "waysted",
      "weapon",
      "weenie",
      "weewee",
      "welcher",
      "welfare",
      "wetb",
      "wetback",
      "wetspot",
      "whacker",
      "whash",
      "whigger",
      "whiskey",
      "whiskeydick",
      "whiskydick",
      "whit",
      "whitenigger",
      "whites",
      "whitetrash",
      "whitey",
      "whiz",
      "whop",
      "whore",
      "whorefucker",
      "whorehouse",
      "wigger",
      "willie",
      "williewanker",
      "willy",
      "wn",
      "wog",
      "women's",
      "wop",
      "wtf",
      "wuss",
      "wuzzie",
      "xtc",
      "xxx",
      "yankee",
      "yellowman",
      "zigabo",
      "zipperhead",
      "nword",
      "n-word",
      "bawbag",
      "bloody",
      "bollocks",
      "bonehead",
      "chump",
      "dirtbag",
      "doofus",
      "dump",
      "freak",
      "git",
      "goof",
      "knucklehead",
      "lunkhead",
      "maggot",
      "nitwit",
      "numbskull",
      "nutter",
      "parasite",
      "pig",
      "plonker",
      "prat",
      "scatterbrain",
      "scumbag",
      "sponger",
      "tightwad",
      "wannabe",
      "weirdo",
    ]);

    this.leetMap = {
      4: "a",
      "@": "a",
      3: "e",
      1: "i",
      "!": "i",
      0: "o",
      $: "s",
      5: "s",
      7: "t",
      "+": "t",
      2: "z",
    };

    this.profaneSymbols = [
      /8={2,}D/,
      /8-{2,}D/,
      /8-{2,}/,
      /:-\)/,
      /:-\(/,
      /:-D/,
      /\.i\./,
      /\.l\./,
      /\.I\./,
      /\.t./,
      /:--+/,
      /:={2,}/,
    ];

    this.lineOneInput = this.querySelector("#engraving_line_one");
    this.lineTwoInput = this.querySelector("#engraving_line_two");
    this.lineThreeInput = this.querySelector("#engraving_line_three");
    this.termsCheckbox = this.querySelector("#acceptTerms");
    this.submitButton = this.querySelector('button[type="submit"]');

    this.errorWrapper = this.querySelector(
      ".product-form__error-message-wrapper",
    );
    this.errorMessage = this.querySelector(".product-form__error-message");

    if (this.lineOneInput) {
      this.lineOneInput.addEventListener("input", (e) => {
        this.handleInput(e, "line-1", "#hidden_engrave_line_one");
        this.toggleSubmitButton();
      });
    }

    if (this.lineTwoInput) {
      this.lineTwoInput.addEventListener("input", (e) => {
        this.handleInput(e, "line-2", "#hidden_engrave_line_two");
      });
    }

    if (this.lineThreeInput) {
      this.lineThreeInput.addEventListener("input", (e) => {
        this.handleInput(e, "line-3", "#hidden_engrave_line_three");
      });
    }

    if (this.termsCheckbox) {
      this.termsCheckbox.addEventListener("change", () => {
        this.toggleSubmitButton();
      });
    }

    this.toggleSubmitButton();

    const form = this.querySelector("form");

    if (form) {
      form.addEventListener(
        "submit",
        (e) => {
          if (!this.validateForm()) {
            e.preventDefault();
            e.stopImmediatePropagation();

            if (this.submitButton) {
              this.submitButton.removeAttribute("aria-disabled");
            }

            return;
          }

          this.updateMessageField();
        },
        { capture: true },
      );
    }

    document.addEventListener("pdp_add_to_cart", () => {
      const quickViewModal = this.closest("engraving-quick-view");

      if (quickViewModal && quickViewModal.classList.contains("open")) {
        quickViewModal.classList.remove("open");
      }
    });
  }

  updatePreview() {
    const wrapper = this.closest(".quick-view__wrapper");

    if (!wrapper) return;

    this.previewLineOne =
      this.previewLineOne || wrapper.querySelector('[data-preview-line="1"]');

    this.previewLineTwo =
      this.previewLineTwo || wrapper.querySelector('[data-preview-line="2"]');

    this.previewLineThree =
      this.previewLineThree || wrapper.querySelector('[data-preview-line="3"]');

    if (this.previewLineOne) {
      this.previewLineOne.textContent = this.lineOneInput?.value || "";
    }

    if (this.previewLineTwo) {
      this.previewLineTwo.textContent = this.lineTwoInput?.value || "";
    }

    if (this.previewLineThree) {
      this.previewLineThree.textContent = this.lineThreeInput?.value || "";
    }
  }

  updatePreviewOffset() {
    const wrapper = this.closest(".quick-view__wrapper");
    const preview = wrapper?.querySelector(".engraving-preview");

    if (!preview) return;

    const lines = preview.querySelectorAll(".engraving-preview__svg-text");
    const width = preview.offsetWidth;

    let offsetX = 0;

    if (
      preview.dataset.kind === "fragrance" &&
      preview.dataset.size === "200ml" &&
      width <= 1135
    ) {
      offsetX = -1;
    }

    lines.forEach((line) => {
      line.setAttribute("transform", `translate(${offsetX} 0)`);
    });
  }

  toggleSubmitButton() {
    if (!this.submitButton) {
      return;
    }

    const lineOneText = this.lineOneInput ? this.lineOneInput.value.trim() : "";
    const isTermsAccepted = this.termsCheckbox
      ? this.termsCheckbox.checked
      : false;

    if (lineOneText !== "" && isTermsAccepted) {
      this.submitButton.disabled = false;
    } else {
      this.submitButton.disabled = true;
    }
  }

  handleInput(e, dataAttribute, hiddenFieldId) {
    this.hideError();

    let rawValue = e.target.value;
    let sanitizedValue = rawValue.replace(this.illegalCharsRegex, "");

    if (sanitizedValue.length > 15) {
      sanitizedValue = sanitizedValue.substring(0, 15);
    }

    if (rawValue !== sanitizedValue) {
      e.target.value = sanitizedValue;
    }

    this.setAttribute(`data-${dataAttribute}`, sanitizedValue);

    const hiddenField = this.querySelector(hiddenFieldId);

    if (hiddenField) {
      hiddenField.value = sanitizedValue;
    }

    this.updateMessageField();
    this.updatePreview();
  }

  updateMessageField() {
    const lineOne = this.lineOneInput ? this.lineOneInput.value : "";
    const lineTwo = this.lineTwoInput ? this.lineTwoInput.value : "";
    const lineThree = this.lineThreeInput ? this.lineThreeInput.value : "";

    let message = lineOne;

    if (lineTwo) {
      message += ` / ${lineTwo}`;
    }

    if (lineThree) {
      message += ` / ${lineThree}`;
    }

    const hiddenMessage = this.querySelector("#hidden_message");

    if (hiddenMessage) {
      hiddenMessage.value = message;
    }
  }

  normalizeWord(word) {
    if (!word) {
      return "";
    }

    return word
      .toLowerCase()
      .split("")
      .map((char) => this.leetMap[char] || char)
      .join("")
      .trim();
  }

  hasProfanity(text) {
    if (!text) {
      return false;
    }

    for (const symbolRegex of this.profaneSymbols) {
      if (symbolRegex.test(text)) {
        return true;
      }
    }

    const words = text.toLowerCase().split(/[^a-zA-Z0-9@$!+]+/);

    for (const word of words) {
      if (!word) {
        continue;
      }

      const normalized = this.normalizeWord(word);

      if (this.profanitySet.has(normalized)) {
        return true;
      }
    }

    return false;
  }

  validateForm() {
    const lineOneText = this.lineOneInput ? this.lineOneInput.value : "";
    const lineTwoText = this.lineTwoInput ? this.lineTwoInput.value : "";
    const lineThreeText = this.lineThreeInput ? this.lineThreeInput.value : "";

    const combinedText = `${lineOneText} ${lineTwoText} ${lineThreeText}`;

    if (!lineOneText.trim()) {
      this.showError("First line is required for engraving.");

      return false;
    }

    if (this.hasProfanity(combinedText)) {
      this.showError("Profanity and offensive language are not allowed.");

      return false;
    }

    if (this.termsCheckbox && !this.termsCheckbox.checked) {
      this.showError("You must accept the terms and conditions.");

      return false;
    }

    return true;
  }

  showError(message) {
    if (this.errorWrapper && this.errorMessage) {
      this.errorMessage.textContent = message;
      this.errorWrapper.removeAttribute("hidden");
    }
  }

  hideError() {
    if (this.errorWrapper) {
      this.errorWrapper.setAttribute("hidden", "");
    }
  }
}

customElements.define("product-engraving", ProductEngraving);

class EngravingQuickView extends HTMLElement {
  constructor() {
    super();
  }

  async renderAndOpen(handle) {
    try {
      const root = window?.Shopify?.routes?.root || "/";
      const url = `${root}products/${handle}?section_id=product-engrave-quick-view`;

      const requestQuickView = await fetch(url, {
        method: "GET",
        credentials: "same-origin",
      });

      const quickViewResponse = await requestQuickView.text();

      let p = new DOMParser();
      let doc = p.parseFromString(quickViewResponse, "text/html");
      let template = doc.querySelector(".quick-view__wrapper");

      this.innerHTML = template.outerHTML;
      this.classList.add("open");

      const productEngraving = this.querySelector("product-engraving");

      if (productEngraving && productEngraving.updateMessageField) {
        productEngraving.updateMessageField();
        productEngraving.updatePreview();
      }

      const closeButtons = this.querySelectorAll("[data-modal-close]");

      closeButtons.forEach((button) => {
        button.addEventListener("click", () => {
          this.close();
        });
      });
    } catch (error) {
      console.error(
        `There was an error generating the product quick view -> ${error}`,
      );
    }
  }

  close() {
    this.classList.remove("open");
  }
}

customElements.define("engraving-quick-view", EngravingQuickView);

class EngravingQuickViewOpen extends HTMLElement {
  constructor() {
    super();

    const handle = this.getAttribute("data-handle");

    this.addEventListener("click", (e) => {
      e.preventDefault();

      const quickView = document.querySelector("engraving-quick-view");

      if (quickView) {
        quickView.renderAndOpen(handle);
      } else {
        console.warn(
          "No <engraving-quick-view> element found or renderAndOpen() missing.",
        );
      }
    });
  }
}

customElements.define("engraving-quick-view-open", EngravingQuickViewOpen);
